import { yup } from '@framework/validation';
import { FormBuilderMetaFlags } from '../../../../../../validator/form-builder/flags/FormBuilderMetaFlags';
import { mapReferenceToPath } from '../../../../../expressions/evaluate/mapReferenceToPath';
import { IBaseWidget } from '../../../../IBaseWidget';
import { IParentWidgetScope, IWidgetType } from '../../../../IWidgetType';
import { ConfirmWidgetValue } from '../IConfirmWidget';
import { isConfirmableWidget } from './ConfirmationConfigSchema';

/**
 * Gestione della "Conferma"
 */
export function setConfirmationFormSchemaRules(
  schema: yup.AnySchema,
  flags: Record<string, any>,
  options: {
    widget: IBaseWidget;
    widgetType: IWidgetType<any> | null;
    parentScope: IParentWidgetScope;
  },
) {
  const { widget, widgetType, parentScope } = options;

  if (!isConfirmableWidget(widget) || widget.confirmation == null)
    return schema;

  // Non applico le regole di conferma se il widget
  // richiede di saltare i valori di default.
  if (flags[FormBuilderMetaFlags.SkipDefaultValue]) return schema;

  const path = mapReferenceToPath(widget.confirmation);

  return schema.parentWhen([path], ([confirmationValue], schema) => {
    if (
      !confirmationValue ||
      confirmationValue === ConfirmWidgetValue.ConfirmedDefault ||
      confirmationValue === ConfirmWidgetValue.Unconfirmed
    ) {
      return schema.enabled(false).transform(() => schema.getDefault());
    }

    /**
     * Una volta confermato il valore, non è più possibile modificarlo.
     * (a meno di richiedere nuovamente la modifica)
     */
    if (confirmationValue === ConfirmWidgetValue.ConfirmedModified) {
      return schema.layoutEnabled(false);
    }

    // Enabled di default da `setEditableCondition`
    return schema;
  });
}
